import { render, staticRenderFns } from "./DeliveryRecord.vue?vue&type=template&id=73a52498&scoped=true"
import script from "./DeliveryRecord.vue?vue&type=script&lang=js"
export * from "./DeliveryRecord.vue?vue&type=script&lang=js"
import style0 from "./DeliveryRecord.vue?vue&type=style&index=0&id=73a52498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a52498",
  null
  
)

export default component.exports